module.exports = __webpack_public_path__ + "img/card_detallado_intervecion.c1f6d338.svg";